export const BOT = 'bot'
